import { Widget } from 'jamespot-front-business';
import { CSSProperties, useMemo } from 'react';
import { shallowEqual } from 'react-redux';
import styled, { useTheme } from 'styled-components';
import { useAppSelector } from '../../../../redux/store';
import { commonComponentsRegistry } from '../../../../registry/CommonRegistry';

const JRCHtml = commonComponentsRegistry.getLazyComponent('Html');

export const CSSWidgetTitle = styled.div`
    padding: ${(props) => props.theme.space.md}px;
    border-bottom: 1px solid ${(props) => props.theme.color.grey1};
`;

export const WidgetTitle = ({ uniqid }: { uniqid: string }) => {
    const widgetWrapper = useAppSelector((state) => Widget.selectors.selectWidget(state, uniqid), shallowEqual);
    const theme = useTheme();
    const styles = useAppSelector((state) => Widget.selectors.selectWidgetTitleStyle(state, uniqid), shallowEqual);

    const initialValues = useMemo(() => {
        return {
            color: styles && styles['color'] ? String(styles['color']) : theme.color.black,
            backgroundColor:
                styles && styles['background-color'] ? String(styles['background-color']) : theme.color.white,
            fontSize: styles && styles['font-size'] ? `${styles['font-size']}px` : '24px',
            fontWeight: styles && styles['font-weight'] ? String(styles['font-weight']) : 'medium',
            textAlign: styles && styles['text-align'] ? String(styles['text-align']) : 'left',
        };
    }, [styles, theme]);

    const title = useMemo(() => {
        return widgetWrapper && typeof widgetWrapper.title === 'string' && widgetWrapper.title.length !== 0
            ? widgetWrapper.title
            : undefined;
    }, [widgetWrapper]);

    if (!title) return <></>;

    return (
        <CSSWidgetTitle
            style={{
                color: initialValues.color,
                backgroundColor: initialValues.backgroundColor,
                fontSize: initialValues.fontSize,
                fontWeight: initialValues.fontWeight,
                textAlign: initialValues.textAlign as CSSProperties['textAlign'],
            }}>
            <JRCHtml as="span" __html={title} />
        </CSSWidgetTitle>
    );
};
